var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.85 18.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b8d2d3",
    d: "M14.42,3.37a1.11,1.11,0,1,0,1.1,1.1,1.11,1.11,0,0,0-1.1-1.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b8d2d3",
    d: "M9.5,4.78a4.65,4.65,0,1,0,4.65,4.65A4.65,4.65,0,0,0,9.5,4.78m0,7.62a3,3,0,1,1,3-3,3,3,0,0,1-3,3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b8d2d3",
    d: "M13.19,18.85H5.66A5.67,5.67,0,0,1,0,13.19V5.66A5.67,5.67,0,0,1,5.66,0h7.53a5.67,5.67,0,0,1,5.66,5.66v7.53a5.67,5.67,0,0,1-5.66,5.66M5.66,1.77A3.9,3.9,0,0,0,1.77,5.66v7.53a3.89,3.89,0,0,0,3.89,3.89h7.53a3.89,3.89,0,0,0,3.89-3.89V5.66a3.89,3.89,0,0,0-3.89-3.89Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram2);
export default __webpack_public_path__ + "static/media/instagram-2.b2937530bf150f62e8e0eef939d0fcc1.svg";
export { ForwardRef as ReactComponent };